// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"ba3d152b","6959":"dddcf048"}[chunkId] + ".chunk.css";
};